import React from 'react';
import Layout from '../../components/layout/Layout';

const SellerDashboard = () => {
  return (
    <Layout title="Seller Dashboard">
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{
          background: 'var(--bg-card)',
          padding: '32px',
          borderRadius: '12px',
          border: '1px solid var(--border)'
        }}>
          <h2 style={{ 
            fontFamily: 'Outfit, sans-serif',
            fontWeight: '700', 
            fontSize: '20px', 
            marginBottom: '16px',
            color: 'var(--text)'
          }}>
            Seller Dashboard
          </h2>
          <p style={{ fontSize: '14px', color: 'var(--text-muted)' }}>
            Welcome to the Seller Portal - Manage your products and sales
          </p>
          
          {/* Quick Stats */}
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
            gap: '16px',
            marginTop: '24px'
          }}>
            <div style={{
              padding: '20px',
              background: 'var(--bg-deep)',
              borderRadius: '12px',
              border: '1px solid var(--border)'
            }}>
              <h3 style={{ fontSize: '24px', fontWeight: '700', color: 'var(--primary)', margin: '0 0 8px 0' }}>
                0
              </h3>
              <p style={{ fontSize: '14px', color: 'var(--text-muted)', margin: 0 }}>Total Products</p>
            </div>
            
            <div style={{
              padding: '20px',
              background: 'var(--bg-deep)',
              borderRadius: '12px',
              border: '1px solid var(--border)'
            }}>
              <h3 style={{ fontSize: '24px', fontWeight: '700', color: 'var(--success)', margin: '0 0 8px 0' }}>
                0
              </h3>
              <p style={{ fontSize: '14px', color: 'var(--text-muted)', margin: 0 }}>Total Sales</p>
            </div>
            
            <div style={{
              padding: '20px',
              background: 'var(--bg-deep)',
              borderRadius: '12px',
              border: '1px solid var(--border)'
            }}>
              <h3 style={{ fontSize: '24px', fontWeight: '700', color: 'var(--accent)', margin: '0 0 8px 0' }}>
                ₹0
              </h3>
              <p style={{ fontSize: '14px', color: 'var(--text-muted)', margin: 0 }}>Revenue</p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SellerDashboard;
